import { createClient } from '@supabase/supabase-js';

// Access environment variables defined in .env.local
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = import.meta.env.VITE_SUPABASE_KEY;

// FAIL-SAFE: If variables are missing (e.g. forgot to redeploy), 
// use placeholders to prevent the "White Screen of Death".
// The app won't connect, but it will load and show errors in the console.
const validUrl = supabaseUrl || 'https://placeholder.supabase.co';
const validKey = supabaseKey || 'placeholder-key';

if (!supabaseUrl || !supabaseKey) {
    console.error('CRITICAL: Supabase keys are missing! Check .env.local or Vercel Settings.');
}

export const supabase = createClient(validUrl, validKey);